// extracted by mini-css-extract-plugin
export default {"container":"zY4m_3","text":"JGUTjq","image":"YCyqvX"};